<!-- Header -->
<ion-header class="ion-no-border">
  <ion-toolbar mode="ios">
    <ion-buttons slot="end">
      <ion-button (click)="dismiss()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<!-- Content -->
<ion-content [scrollY]="false">
  <ion-label class="title">{{ 'ACCOUNT.language.title' | translate }}</ion-label>
  <div class="languages-list" *ngIf="customer.app_location !== 'ch'; else swissOptions">
    <div class="languages-list__item" (click)="selectLanguage(Languages.DE_DE)">
      <p>{{ 'ACCOUNT.language.de' | translate }}</p>
      <ion-icon *ngIf="selectedLanguage === Languages.DE_DE" name="checkmark-circle-outline"></ion-icon>
      <ion-icon *ngIf="selectedLanguage !== Languages.DE_DE" name="ellipse-outline"></ion-icon>
    </div>
    <div class="languages-list__item" (click)="selectLanguage(Languages.EN_DE)">
      <p>{{ 'ACCOUNT.language.en' | translate }}</p>
      <ion-icon *ngIf="selectedLanguage === Languages.EN_DE" name="checkmark-circle-outline"></ion-icon>
      <ion-icon *ngIf="selectedLanguage !== Languages.EN_DE" name="ellipse-outline"></ion-icon>
    </div>
  </div>
  <ng-template #swissOptions>
    <div class="languages-list">
      <div class="languages-list__item" (click)="selectLanguage(Languages.DE_CH)">
        <p>{{ 'ACCOUNT.language.de' | translate }}</p>
        <ion-icon *ngIf="selectedLanguage === Languages.DE_CH" name="checkmark-circle-outline"></ion-icon>
        <ion-icon *ngIf="selectedLanguage !== Languages.DE_CH" name="ellipse-outline"></ion-icon>
      </div>
      <div class="languages-list__item" (click)="selectLanguage(Languages.FR_CH)">
        <p>{{ 'ACCOUNT.language.fr' | translate }}</p>
        <ion-icon *ngIf="selectedLanguage === Languages.FR_CH" name="checkmark-circle-outline"></ion-icon>
        <ion-icon *ngIf="selectedLanguage !== Languages.FR_CH" name="ellipse-outline"></ion-icon>
      </div>
      <div class="languages-list__item" (click)="selectLanguage(Languages.EN_CH)">
        <p>{{ 'ACCOUNT.language.en' | translate }}</p>
        <ion-icon *ngIf="selectedLanguage === Languages.EN_CH" name="checkmark-circle-outline"></ion-icon>
        <ion-icon *ngIf="selectedLanguage !== Languages.EN_CH" name="ellipse-outline"></ion-icon>
      </div>
    </div>
  </ng-template>
</ion-content>
